// extracted by mini-css-extract-plugin
export default {"page":"NotionPage_page__aZO6P"};